import { SignUpQuestionId } from '../questionService/questionModules/signUpQuestionModules'
import {
  QuestionTypeWithOptions,
  QuestionTypeWithoutOptions,
} from '../questionService/questionService'

// todo: include ReactNode as well as string
export interface SignUpScreen {
  title?: string
  description: string
  helperText?: string
  buttonText: string
  backText: string
  questions: SignUpQuestionId[]
}

interface BaseUiQuestion {
  placeholder?: string
  label?: string
  subText?: string
}

interface QuestionWithoutOptions extends BaseUiQuestion {
  type: QuestionTypeWithoutOptions
  options: null
}

export const QuestionType = {
  ...QuestionTypeWithoutOptions,
  ...QuestionTypeWithOptions,
}

interface QuestionWithOptions extends BaseUiQuestion {
  type: QuestionTypeWithOptions
  options: QuestionOption[]
}

export interface QuestionOption {
  name: string
  value: string
  helperText?: string
}

export type Question = QuestionWithOptions | QuestionWithoutOptions

type SignUpAnswer = string

export type SignUpAnswers = {
  [key: string]: SignUpAnswer
}
